import { useMemo } from 'react';
import { lightTheme } from '@azure/communication-react';
import { useTheme } from '@material-ui/core';
export function useAcsTheme() {
    const theme = useTheme();
    return useMemo(() => {
        return Object.assign(Object.assign({}, lightTheme), { palette: Object.assign(Object.assign({}, lightTheme.palette), { themePrimary: theme.palette.primary.main }), semanticColors: Object.assign(Object.assign({}, lightTheme.semanticColors), { bodyBackground: theme.palette.background.paper, primaryButtonText: theme.palette.primary.contrastText }) });
    }, [theme]);
}
